import React from 'react';
import { LuMessagesSquare } from "react-icons/lu";
import { GiBrain } from "react-icons/gi";
import { MdOutlineReportProblem } from "react-icons/md";
import { FaBusinessTime } from "react-icons/fa6";


const Skillspanel = ({params}) => (
    <div className="card">
    <div className="card-header">
      <p className="ar">Soft Skills</p>
      <p className="en">مهارات الناعمة</p>

    </div>
    <div className="card-body">

    <h2 style={{color: '#40739e'}}><LuMessagesSquare /></h2>
      <b style={{color: '#40739e'}}>مهارات التواصل</b>
        <ul>
            <li>تكوين علاقات اجتماعية ناجحة</li>
        </ul>
        <hr></hr>
    <h2 style={{color: '#40739e'}}><FaBusinessTime /></h2>
    <b style={{color: '#40739e'}}>مهارات التنظيم والتخطيط</b>
        <ul>
            <li>الالتزام بالمواعيد</li>
            <li>ترتيب الأولويات</li>
        </ul>
    <hr></hr>
    <h2 style={{color: '#40739e'}}><GiBrain /></h2>
      <b style={{color: '#40739e'}}>مهارات التفكير الناقد</b>
        <ul>
            <li>القدرة علي توليد الأفكار</li>
        </ul>
        <hr></hr>
    <h2 style={{color: '#40739e'}}><MdOutlineReportProblem /></h2>
      <b style={{color: '#40739e'}}>مهارات ادارة الازمات</b>
            <ul>
                <li>مهارة حل المشكلات</li>
            </ul>
        
    </div>
  </div>

);

export default Skillspanel;
